import { clockLabel, dayLabel } from 'helper/timeLabels';
import useText from 'hooks/useText';

/**
 * A history, the newest first: each step in a grey circle on a line, what
 * happened and when, then the details of a change. `items`: [{ id, icon (an
 * element), text, at (Date), lines }].
 */
const ActivityTimeline = ({ items }) => {
  const { text } = useText('activity');
  return (
    <ol className="flex flex-col">
      {items.map((item, index) => (
        <li key={item.id} className="flex gap-3">
          <span className="flex flex-col items-center">
            <span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-gray-100 text-gray-700">
              {item.icon}
            </span>
            {index < items.length - 1 && <span className="w-px flex-1 bg-gray-200" />}
          </span>
          <div className="min-w-0 flex-1 pb-4">
            <p className="text-sm font-medium text-gray-900">{item.text}</p>
            <p className="text-xs text-gray-500">{text('at', { day: dayLabel(item.at), time: clockLabel(item.at) })}</p>
            {item.lines?.map((line) => (
              <p key={line} className="mt-1 text-xs text-gray-700">
                {line}
              </p>
            ))}
          </div>
        </li>
      ))}
    </ol>
  );
};

export default ActivityTimeline;
